import {
  Group as GroupIcon,
  Settings as SettingsIcon,
  Inventory2 as ProductsIcon,
  Factory as FactoryIcon,
  People as PeopleIcon,
  LocalShipping as LocalShippingIcon,
  MenuBook as MenuBookIcon,
  Dashboard as DashboardIcon,
  AddShoppingCart as NewOrderIcon,
  ReceiptLong as OrderListIcon,
} from '@mui/icons-material';

export const adminMenuSections = [
  {
    // Sin título: queda arriba de todo, fuera de las secciones
    title: null,
    items: [
      { text: 'Dashboard', icon: DashboardIcon, path: '/dashboard', permission: null },
    ],
  },
  {
    title: 'Pedidos al público',
    items: [
      { text: 'Nuevo Pedido', icon: NewOrderIcon, path: '/orders/public', permission: 'orders.add_order' },
      { text: 'Pedidos', icon: OrderListIcon, path: '/orders/public/list', permission: 'orders.view_order' },
      { text: 'Clientes', icon: PeopleIcon, path: '/orders/public/clients', permission: 'clients.view_client' },
      { text: 'Productos', icon: ProductsIcon, path: '/orders/public/products', permission: 'products.view_product' },
    ],
  },
  {
    title: 'Pedidos mayoristas',
    items: [
      { text: 'Nuevo Pedido', icon: NewOrderIcon, path: '/orders/business', permission: 'orders.add_order' },
      { text: 'Pedidos', icon: OrderListIcon, path: '/orders/business/list', permission: 'orders.view_order' },
      { text: 'Clientes', icon: PeopleIcon, path: '/orders/business/clients', permission: 'clients.view_client' },
      { text: 'Productos', icon: ProductsIcon, path: '/orders/business/products', permission: 'products.view_product' },
    ],
  },
  {
    title: 'Producción',
    items: [
      { text: 'Producción', icon: FactoryIcon, path: '/production', permission: 'orders.view_order' },
    ],
  },
  {
    title: 'Reparto',
    items: [
      { text: 'Viajes', icon: LocalShippingIcon, path: '/trips', permission: 'delivery.view_trip' },
    ],
  },
  {
    title: 'Tango',
    items: [
      { text: 'Clientes', icon: PeopleIcon, path: '/clients', permission: 'clients.view_client' },
      { text: 'Productos', icon: ProductsIcon, path: '/products', permission: 'products.view_product' },
    ],
  },
  {
    title: 'General',
    items: [
      { text: 'Usuarios', icon: GroupIcon, path: '/users', permission: 'capriuser.view_user' },
      { text: 'Configuración', icon: SettingsIcon, path: '/settings', permission: 'settings.view_setting' },
    ],
  },
  {
    title: 'Documentación',
    items: [
      // Páginas estáticas servidas desde public/; se abren fuera del router
      { text: 'Manual de Uso', icon: MenuBookIcon, path: '/manual.html', external: true, permission: null },
    ],
  },
];

export const wholesaleMenuSections = [
  {
    title: 'Pedidos mayoristas',
    items: [
      { text: 'Nuevo Pedido', icon: NewOrderIcon, path: '/orders/business', permission: null },
      { text: 'Mis Pedidos', icon: OrderListIcon, path: '/orders/business/list', permission: null },
    ],
  },
];

// Página de inicio tras el login: el Dashboard para usuarios internos,
// y la sección de pedidos para los mayoristas del portal (sin acceso al Dashboard).
export const getHomePath = (user) =>
  user?.is_wholesale_client ? '/orders/business' : '/dashboard';
